export const END_CLAMP_MAX = 0.99999;
export const AUDIO_PROCESSOR_VISUALIZATION_DOWNSAMPLE_FACTOR = 150;
export const MIN_AUDIO_UPLOAD_SIZE_MS = 1000;
export const MAX_AUDIO_UPLOAD_SIZE_MS = 1000 * 30;
export const MIN_REGION_SIZE_MS = 1000;
export const MAX_REGION_SIZE_MS = 4000;
export const MAX_UPLOAD_DURATION_MS = 5 * 60 * 1000;
